module.exports = __webpack_public_path__ + "assets/img/plane-white.264e7a3f.svg";